import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function UseEngagementActions() {
    return (
        <OnboardingBody title='Use actions with forms & Scheduler' statusText='Engagement bar'>
            <p>
                Train your chatbot for conversations, set up your Nutshell Scheduler for booking
                appointments, and establish specific forms and rules for emails, calls, texts, and
                quotes.
            </p>
        </OnboardingBody>
    );
}
